import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-company-joblist',
  templateUrl: './company-joblist.component.html',
  styleUrls: ['./company-joblist.component.css'],
})
export class CompanyJoblistComponent {
  @Input() companyId: string = '';

  alertEmail = '';
  emailError = '';
  emailSuccess = '';

  subscribeEmail() {
    this.emailError = '';
    this.emailSuccess = '';
    const email = this.alertEmail.trim();
    if (!email) { this.emailError = 'Please enter your email.'; return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.emailError = 'Please enter a valid email address.'; return;
    }
    this.emailSuccess = "✓ Subscribed! We'll notify you of new jobs.";
    this.alertEmail = '';
  }
}